import { Popover } from 'foundations-components/transitional/components/Popover';
import { H5 } from 'foundations-components/transitional/components/H5';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerGroupActionDeleteButtonPopover = props => {
  const {
    children,
    onConfirm,
    onCancel,
    isOpen
  } = props;
  const onConfirmLocal = useCallback(event => {
    event.stopPropagation();
    onConfirm();
  }, [onConfirm]);
  const onCancelLocal = useCallback(event => {
    event.stopPropagation();
    onCancel();
  }, [onCancel]);
  return /*#__PURE__*/_jsx(Popover, {
    content: {
      header: /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filtersViewer.groupDeletePopoverHeader"
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.filtersViewer.groupDeletePopoverBody"
      }),
      footer: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-test-id": "delete-group-confirm",
          onClick: onConfirmLocal,
          size: "sm",
          use: "danger",
          responsive: false,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "newCustomerDataFilters.filtersViewer.groupDeletePopoverConfirm"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onCancelLocal,
          size: "sm",
          use: "tertiary-light",
          responsive: false,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "newCustomerDataFilters.filtersViewer.groupDeletePopoverCancel"
          })
        })]
      })
    },
    open: isOpen,
    placement: "right",
    inlineSize: "330px",
    children: children
  });
};
export default ViewerGroupActionDeleteButtonPopover;